import { Rule } from 'glamor'

import { isKey } from '../../utils'
import { UiTheme } from '../../theme'

export default (theme: UiTheme) => {
  const commonPadding = `${theme.settings.spacing.large} ${theme.settings.spacing.xLarge}`

  return {
    card: {
      base: {
        boxShadow: theme.settings.shadows.elevation[0],
        borderRadius: theme.settings.borderRadiuses.regular,
        flex: 1,
        marginBottom: theme.settings.spacing.large,

        '@media print': {
          border: 'none',
        },
      },

      borderless: {
        boxShadow: 'none',
        borderWidth: 0,
      },

      flush: {
        marginBottom: 0,
      },

      tight: {
        marginBottom: theme.settings.spacing.medium,
      },

      hoverable: {
        cursor: 'pointer',
        transition: `box-shadow ${theme.settings.transitions.regular}`,
        ':hover': {
          boxShadow: theme.settings.shadows.elevation[1],
        },
      },

      variants: {
        white: {
          border: theme.settings.borders.regular,
          background: 'white',
          color: theme.colors.text.normal,
        },
        ...['cta', 'primary', 'secondary', 'negative', 'positive', 'alert', 'brand', 'content'].reduce(
          (acc: { [key: string]: Rule }, color) => {
            if (isKey(theme.colors.backgrounds, color)) {
              acc[color] = {
                border: theme.settings.borders.regular,
                background: theme.colors.backgrounds[color],
                color: theme.colors.text.normal,
              }
            }
            return acc
          },
          {}
        ),
      },
    },

    header: {
      base: {
        padding: commonPadding,

        '@media print': {
          padding: 0,
        },
      },

      flush: {
        padding: 0,
      },

      tight: {
        padding: `${theme.settings.spacing.medium} ${theme.settings.spacing.large}`,
      },

      tightNoBorder: {
        paddingBottom: 0,
      },

      border: {
        borderBottom: theme.settings.borders.dim,
      },
    },

    footer: {
      base: {
        padding: commonPadding,

        '@media print': {
          padding: 0,
        },
      },

      flush: {
        padding: 0,
      },

      tight: {
        padding: `${theme.settings.spacing.medium} ${theme.settings.spacing.large}`,
      },

      tightNoBorder: {
        paddingTop: 0,
      },

      border: {
        borderTop: theme.settings.borders.dim,
      },
    },

    heading: {
      base: {
        ...theme.typography.headings.normal,
        margin: 0,
      },
    },

    content: {
      base: {
        padding: commonPadding,

        '@media print': {
          padding: 0,
        },
      },

      flush: {
        padding: 0,
      },

      tight: {
        padding: `${theme.settings.spacing.medium} ${theme.settings.spacing.large}`,
      },
    },
  }
}
